// extracted by mini-css-extract-plugin
export default {"Customizado":"estilo_Customizado__-f3ot","ContainerGrid2Colunas":"estilo_ContainerGrid2Colunas__r0Rvh","Item_Pesquisa":"estilo_Item_Pesquisa__tts0R"};